
export default function LaytonNeighborhoods() {
  const neighborhoods = [
    {
      name: 'East Layton',
      description: 'Serving homes near Layton Hills Mall, East Gate Plaza, and the foothills area with rapid emergency response.',
      icon: 'ri-home-4-line'
    },
    {
      name: 'North Layton',
      description: 'Providing restoration services for properties along Hill Field Road and northern Layton residential areas.',
      icon: 'ri-building-line'
    },
    {
      name: 'Cherry Lane Area',
      description: 'Expert water damage and disaster cleanup for homes and businesses near Cherry Lane and Gentile Street.',
      icon: 'ri-community-line'
    },
    {
      name: 'Layton Commons',
      description: 'Commercial and residential restoration services for properties near Layton Commons shopping district.',
      icon: 'ri-store-2-line'
    },
    {
      name: 'West Layton',
      description: 'Fast response for water damage, flooding, and fire restoration in West Layton neighborhoods.',
      icon: 'ri-map-pin-2-line'
    },
    {
      name: 'Adams Avenue Corridor',
      description: 'Comprehensive disaster cleanup services for homes and businesses along Adams Avenue and surrounding streets.',
      icon: 'ri-road-map-line'
    }
  ];

  return (
    <section className="py-12 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
            Layton Neighborhoods We Serve
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            Fast water damage restoration response throughout all Layton areas
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {neighborhoods.map((neighborhood, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-5 md:p-8 shadow-sm hover:shadow-lg transition-all hover:-translate-y-1"
            >
              <div className="w-11 h-11 md:w-14 md:h-14 bg-sky-100 rounded-full flex items-center justify-center mb-4 md:mb-6">
                <i className={`${neighborhood.icon} text-xl md:text-2xl text-sky-600`}></i>
              </div>
              <h3 className="text-base md:text-xl font-bold text-gray-900 mb-2 md:mb-3">{neighborhood.name}</h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">{neighborhood.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
